export default "__VITE_ASSET__e9671e6b__"